import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderConnectionErrorService {

  private connectionErrorListener = new Subject();

  constructor() { }

  public showConnectionError(show) {
    this.connectionErrorListener.next(show);
  }

  public connectionErrorListen() {
    return this.connectionErrorListener.asObservable();
  }
}
